module.exports = __webpack_public_path__ + "static/img/8.3fabe4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/8.png
// module id = ++Nx
// module chunks = 4